import { useCallback, useState } from 'react';
import { Edge, EdgeMarker, MarkerType } from '@xyflow/react';
import { IDepartments } from '../../../../../interface/interfaces';

export const useAddEdges = () => {
    const [edges, setEdges] = useState<Edge[]>([]);

    const connectEdges = useCallback((source: IDepartments, target: IDepartments, output: boolean) => {
        const arrowOut: EdgeMarker = {
            type: MarkerType.ArrowClosed,
            strokeWidth: 2,
            width: 10,
            height: 10,
            color: '#a0a2a3',
        };

        const arrowIn: EdgeMarker = {
            type: MarkerType.ArrowClosed,
            width: 0,
            color: '#a0a2a3',
        };

        const hasConflict = !target.Status && !source.Status;

        const newEdge: Edge = {
            id: `e${source.DepartmentId}-${target.DepartmentId}`,
            source: `${source.DepartmentId}`,
            target: `${target.DepartmentId}`,
            data: {
                target: target.DepartmentName,
                source: source.DepartmentName,
            },
            // animated: hasConflict ? true : false,
            animated: true,
            markerEnd: arrowOut,
            // label:`${source.department} -> ${target.department}`,
            // style: { strokeWidth: hasConflict ? 2 : 4, stroke: `${hasConflict ? '#77b800' : '#e1142c'}` },
            style: { strokeWidth: 2, stroke: `${output && '#a0a2a3'}` },
        };

        setEdges((eds) => [...eds, newEdge]);
    }, []);

    const clearEdges = useCallback(() => {
        setEdges([]);
    }, []);

    return { edges, setEdges, connectEdges, clearEdges };
};
